import { TranslationKey } from 'shared/assets/i18n/hu';
import { GoalOfApplication, ProductType } from 'shared/openapi/models';

const titleMap: Record<ProductType, TranslationKey> = {
	[ProductType.Jelzalog]: 'client.products.mortgage.calculator-name',
	[ProductType.CsokPlusz]: 'client.products.csok-plus.calculator-name',
	[ProductType.Babavaro]: 'client.products.baby-loan.calculator-name',
	[ProductType.OtthonStart]: 'client.products.otthon-start.calculator-name',
};

export function getHeaderTitle(productTypes: ProductType[]) {
	if (productTypes.length === 1) {
		return titleMap[productTypes[0]];
	} else {
		return 'client.calculation-picker.loan-calculator';
	}
}

export function countRequiredSquareMeters(
	goalOfApplication: GoalOfApplication | null | undefined,
	numberOfChildren: number | null | undefined,
	numberOfExpectedChildren: number | null | undefined
) {
	let baseSquareMeters = 60;
	let maxRequiredSquareMeters = 90;

	const flatGoals = [GoalOfApplication.NewFlatBuying, GoalOfApplication.UsedFlatBuying];
	const allChildrenCount = (numberOfChildren ?? 0) + (numberOfExpectedChildren ?? 0);

	if (goalOfApplication && flatGoals.includes(goalOfApplication)) {
		baseSquareMeters = 30;
		maxRequiredSquareMeters = 60;
	}

	const requiredSquareMeters = baseSquareMeters + Math.min(baseSquareMeters, allChildrenCount * 10);

	return Math.min(maxRequiredSquareMeters, requiredSquareMeters);
}
